<script lang="ts" setup>
import backgroundImg from '@/assets/home.webp'
import misja1Img from '@/assets/misja-1.webp'
import misja2Img from '@/assets/misja-2.webp'

const imageSize = useImageSize()
</script>

<template>
  <v-img
    eager
    :src="backgroundImg"
    cover
    height="calc(70svh - var(--v-layout-top)"
    alt=""
  />
  <v-container class="d-flex flex-column ga-6 my-6 my-lg-12">
    <v-row>
      <v-col
        cols="12"
        lg="6"
        align-self="center"
        class="d-flex justify-md-center"
      >
        <div class="d-flex flex-column ga-5 px-lg-12">
          <div class="text-h5 text-lg-h4 font-weight-medium">
            Nasza misja
          </div>
          <p class="text-subtitle-2 font-weight-regular">
            CSM tworzą ludzie skupieni wokół misji rozwoju lokalnych kościołów
            chrześcijańskich w zakresie muzycznej służby uwielbienia.
          </p>
          <p class="text-subtitle-2 font-weight-regular">
            W ramach Misji CSM podejmujemy wiele różnych form działalności;
            prowadzimy uwielbienia na konferencjach chrześcijańskich,
            organizujemy warsztaty muzyczne dla zespołów i grup uwielbienia,
            piszemy i nagrywamy pieśni a także opracowujemy pomocne w rozwoju
            służby muzycznej narzędzia.
          </p>
        </div>
      </v-col>
      <v-col
        cols="12"
        lg="6"
        align-self="center"
      >
        <v-img
          eager
          alt="Nasza misja"
          :aspect-ratio="imageSize"
          class="mt-6 mt-lg-0"
          width="100%"
          height="100%"
          :src="misja2Img"
          color="gray-300"
          rounded="xl"
          cover
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="6"
        order="2"
        order-lg="1"
        align-self="center"
      >
        <v-img
          eager
          alt="Nasza misja"
          :aspect-ratio="imageSize"
          class="mt-6 mt-lg-0"
          width="100%"
          height="100%"
          :src="misja1Img"
          color="gray-300"
          rounded="xl"
          cover
        />
      </v-col>
      <v-col
        cols="12"
        lg="6"
        order="1"
        order-lg="2"
        align-self="center"
        class="d-flex justify-md-center"
      >
        <div class="d-flex flex-column ga-5 px-lg-12">
          <p class="text-subtitle-2 font-weight-regular">
            Głównym projektem Misji CSM jest Szkoła CSM – Centrum Szkolenia
            Muzyków i Liderów Uwielbienia, które działa nieprzerwanie od 2008
            roku. W ciągu ostatnich szesnastu lat w naszych szkoleniach
            uczestniczyło prawie 2000 osób. Obecnie prowadzimy
            dwa kampusy Szkoły CSM: Południe i Warszawa.
          </p>
          <p class="text-subtitle-2 font-weight-regular">
            Pod względem organizacyjnym jesteśmy agendą Kościoła
            Zielonoświątkowego w Polsce, jednak działamy w różnych środowiskach
            chrześcijańskich w naszym kraju. Za główny cel postawiliśmy sobie
            szkolenie muzyków, którzy są lub planują być zaangażowani w służbę
            uwielbienia. Pragniemy wyposażać i inspirować tych, którzy chcą
            swoje umiejętności muzyczne ukierunkowywać na potrzeby muzyki w
            Kościołach Chrześcijańskich.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
